import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
// slices
import productReducer from "./slices/product";
import calendarReducer from "./slices/calendar";
import userReducer from "./slices/user";
import roleReducer from "./slices/role";
import accessReducer from "./slices/access";
// ----------------------------------------------------------------------

export const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

const productPersistConfig = {
  key: "product",
  storage,
  keyPrefix: "redux-",
  whitelist: ["checkout"],
};

export const rootReducer = combineReducers({
  calendar: calendarReducer,
  user: userReducer,
  role: roleReducer,
  access: accessReducer,
  product: persistReducer(productPersistConfig, productReducer),
});
